import { createTiler, TilerWorker, VoxTilerOptions } from '@voximplant/tiler';

let activeTiler: TilerWorker;

const initTiler = (settings: VoxTilerOptions): TilerWorker => {
  return (activeTiler = createTiler(settings));
};

export { activeTiler, initTiler };
